import type { Individual } from "@typings/entities/individuals";
import type { Collar } from ".";

export const collarColumns: Array<{
  id: keyof Collar | "lastLocation" | keyof Individual;
  label: string;
}> = [
  { id: "number", label: "Número" },
  { id: "responsibleTeam", label: "Equipe Responsável" },
  { id: "lastLocation", label: "Última Localização" },
  { id: "ufuName", label: "Nome UFU" },
] as const;
